import { styled, Box } from "@mui/material";

export const CustomUIRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "stretch",
  alignItems: "stretch",
  width: "100%",
  height: "100%",
  color: "#24292b",
  position: "relative",
  pointerEvents: "auto",
}));
